/* Story-Overlay für gemischte Bilder und Shopify-Videos. */
(function () {
  var overlay = document.querySelector('[data-story-overlay]');
  if (!overlay) return;

  var image = overlay.querySelector('[data-story-image]');
  var video = overlay.querySelector('[data-story-video]');
  var title = overlay.querySelector('[data-story-title]');
  var caption = overlay.querySelector('[data-story-caption]');
  var counter = overlay.querySelector('[data-story-counter]');
  var footer = overlay.querySelector('.story-overlay__footer');
  var previous = overlay.querySelector('[data-story-prev]');
  var next = overlay.querySelector('[data-story-next]');

  var story = null;
  var index = 0;
  var alignmentFrame = null;
  var preloadFrame = null;
  var preloadedImages = {};

  function legacyImageUrl(path) {
    if (!path) return '';
    if (/^(?:https?:)?\/\//.test(path) || path.indexOf('/') === 0) return path;
    return '/assets/' + path + (/\.[a-z0-9]+(?:[?#]|$)/i.test(path) ? '' : '.webp');
  }

  function preferredImageWidth() {
    var availableWidth = window.innerWidth <= 599 ? window.innerWidth - 30 : 760;
    var pixelWidth = Math.max(1, availableWidth) * Math.min(window.devicePixelRatio || 1, 2);
    var widths = [480, 760, 1200, 1600, 2400];

    for (var widthIndex = 0; widthIndex < widths.length; widthIndex += 1) {
      if (pixelWidth <= widths[widthIndex]) return widths[widthIndex];
    }
    return widths[widths.length - 1];
  }

  function sizedImageUrl(path) {
    var url = legacyImageUrl(path);
    if (!url || url.indexOf('/cdn/shop/') === -1) return url;

    var width = preferredImageWidth();
    if (/([?&])width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function preloadItem(item) {
    if (!item) return;
    var source = item.type === 'video' ? item.poster : item.src;
    var url = sizedImageUrl(source);
    if (!url || preloadedImages[url]) return;

    var preload = new Image();
    preload.decoding = 'async';
    preload.fetchPriority = 'low';
    preload.src = url;
    preloadedImages[url] = preload;
  }

  function preloadNearby() {
    if (!story || story.media.length < 2) return;
    [1, 2, -1].forEach(function (offset) {
      var nearbyIndex = (index + offset + story.media.length) % story.media.length;
      if (nearbyIndex !== index) preloadItem(story.media[nearbyIndex]);
    });
  }

  function schedulePreload() {
    window.cancelAnimationFrame(preloadFrame);
    preloadFrame = window.requestAnimationFrame(preloadNearby);
  }

  function parseMedia(card) {
    var media;
    try { media = JSON.parse(card.dataset.storyMedia || '[]'); } catch (error) { media = []; }
    if (media.length) return media;

    var images;
    var captions;
    try { images = JSON.parse(card.dataset.storyImages || '[]'); } catch (error) { images = []; }
    try { captions = JSON.parse(card.dataset.storyCaptions || '[]'); } catch (error) { captions = []; }
    return images.map(function (path, mediaIndex) {
      return { type: 'image', src: legacyImageUrl(path), caption: captions[mediaIndex] || '' };
    });
  }

  function clearVideo() {
    video.pause();
    video.removeAttribute('poster');
    while (video.firstChild) video.removeChild(video.firstChild);
    video.load();
  }

  function activeElement() {
    return video.hidden ? image : video;
  }

  function intrinsicSize(element) {
    if (element === video) return { width: video.videoWidth, height: video.videoHeight };
    return { width: image.naturalWidth, height: image.naturalHeight };
  }

  function updateFooterAlignment() {
    window.cancelAnimationFrame(alignmentFrame);
    alignmentFrame = window.requestAnimationFrame(function () {
      if (overlay.hidden) return;
      var element = activeElement();
      var size = intrinsicSize(element);
      if (!size.width || !size.height) return;

      var mediaBox = element.getBoundingClientRect();
      if (!mediaBox.width || !mediaBox.height) return;

      var mediaRatio = size.width / size.height;
      var boxRatio = mediaBox.width / mediaBox.height;
      var renderedWidth;
      var renderedHeight;

      if (mediaRatio > boxRatio) {
        renderedWidth = mediaBox.width;
        renderedHeight = renderedWidth / mediaRatio;
      } else {
        renderedHeight = mediaBox.height;
        renderedWidth = renderedHeight * mediaRatio;
      }

      var bottomInset = Math.max(0, (mediaBox.height - renderedHeight) / 2);
      footer.style.width = renderedWidth + 'px';
      footer.style.transform = 'translateY(-' + bottomInset + 'px)';
      footer.style.visibility = '';
    });
  }

  function render() {
    if (!story) return;
    var item = story.media[index];
    footer.style.visibility = 'hidden';
    clearVideo();

    if (item.type === 'video') {
      image.hidden = true;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      video.hidden = false;
      video.setAttribute('aria-label', story.title + ' — Video ' + (index + 1));
      if (item.poster) video.poster = item.poster;
      (item.sources || []).forEach(function (sourceData) {
        if (!sourceData.src) return;
        var source = document.createElement('source');
        source.src = sourceData.src;
        if (sourceData.type) source.type = sourceData.type;
        video.appendChild(source);
      });
      video.load();
    } else {
      video.hidden = true;
      image.hidden = false;
      image.classList.remove('is-image-loaded');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = sizedImageUrl(item.src);
      image.alt = story.title + ' — Image ' + (index + 1);
      if (image.complete) updateFooterAlignment();
    }

    caption.textContent = item.caption || story.caption || '';
    counter.textContent = (index + 1) + ' / ' + story.media.length;
    schedulePreload();
  }

  function step(delta) {
    if (!story || story.media.length < 2) return;
    index = (index + delta + story.media.length) % story.media.length;
    render();
  }

  function open(card) {
    var media = parseMedia(card);
    if (!media.length) return;
    story = {
      title: card.dataset.storyTitle || '',
      caption: card.dataset.storyCaption || '',
      media: media
    };
    index = 0;
    title.textContent = story.title;
    previous.hidden = story.media.length < 2;
    next.hidden = story.media.length < 2;
    overlay.hidden = false;
    document.body.classList.add('story-open');
    render();
  }

  function close() {
    window.cancelAnimationFrame(preloadFrame);
    clearVideo();
    overlay.hidden = true;
    document.body.classList.remove('story-open');
    story = null;
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.tile-card--article[data-story-media], .tile-card--article[data-story-images]');
    if (card) {
      event.preventDefault();
      open(card);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest && event.target.closest('.tile-card--article[data-story-media], .tile-card--article[data-story-images]');
    if (card && event.target === card) {
      event.preventDefault();
      open(card);
    }
  });

  overlay.querySelector('[data-story-close]').addEventListener('click', close);
  previous.addEventListener('click', function () { step(-1); });
  next.addEventListener('click', function () { step(1); });
  image.addEventListener('load', updateFooterAlignment);
  video.addEventListener('loadedmetadata', updateFooterAlignment);
  window.addEventListener('resize', updateFooterAlignment);

  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) close();
  });

  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });
})();
